import moment from "moment";

export function getEligibleSeasonalPromos(promotionList, promotionMap, discountPanelList, testList) {
  if (promotionList.length === 0 || promotionMap.length === 0 ||discountPanelList.length === 0) {
    return [];
  }
  let fakePromo = {
    "isPercent": null,
    "code": null,
    "supplementIsPercent": null,
    "isBanner": true,
    "expiredDate": null,
    "groupId": 10001,
    "supplementQuantity": null,
    "discountName": "3 for $700, 5 for $1000 Bundle",
    "lastBy": "Jian",
    "finalAmount": 1000,
    "groupContent": {
        "package": [
            584,
            586,
            592,
            594,
            596,
            600,
            602,
            604,
            606,
            610,
            612,
            614,
            620,
            632,
            644,
            650,
            652,
            660,
            665,
            716,
            668,
            671,
            61,
            186,
            187,
            181,
            196,
            197,
            719,
            674,
            59,
            193,
            194,
            668,
            671,
            195,
            695,
            704,
            724,
            828
        ],
        "test": [
            698,
            701
        ],
        "bundle": []
    },
    "id": -203,
    "supplementGroupId": null,
    "lastDate": "2024-07-03T18:46:54.000+00:00",
    "amount": null,
    "quantity": 5,
    "requireamount": null,
    "userId": null,
    "isPined": 1,
    "supplementFinalAmount": null,
    "createdDate": "2024-01-08T05:48:22.000+00:00",
    "createdBy": "Jian",
    "supplementGroupContent": {
        "package": [],
        "test": [],
        "bundle": []
    },
    "comment": null,
    "userType": null,
    "supplementAmount": null,
    "startDate": "2024-01-01T07:00:00.000+00:00",
    "appliedTests": new Set([
      59,
      61,
      181,
      186,
      187,
      193,
      194,
      195,
      196,
      197,
      584,
      586,
      592,
      594,
      596,
      600,
      602,
      604,
      606,
      610,
      612,
      614,
      620,
      632,
      644,
      650,
      652,
      660,
      665,
      668,
      671,
      674,
      695,
      698,
      701,
      704,
      716,
      719,
      724,
      828
  ]),
    "appliedBundles": {},
    "originalPrice": 10391.8,
    "isSelect": false,
    "category": "seasonalPromo",
    "price": 1000,
    "bundleId": -3,
    "testIdsInPromo": {},
    "isOpenXChooseYDialog": false,
    "sampleTypeSets": {
        "blood": {},
        "nonBlood": {},
        "dryIce": {}
    }
}
  promotionList = promotionList.concat(fakePromo)
  // find valid seasonal promotions in promotionList
  let eligibleSeasonalPromotions = promotionList.filter(promo => {
    if (!promo.startDate && !promo.expiredDate) {
      return false;
    }

    let startDate = moment(new Date(promo.startDate)).local();
    let endDate = moment(new Date(promo.expiredDate)).local();
    // handle invalid startDate & endDate cases
    // note that new Date(null) is a valid date, so handle for null value as well
    if (!startDate.isValid() || !promo.startDate) {
      return moment().local().isSameOrBefore(endDate);
    }
    if (!endDate.isValid() || !promo.expiredDate) {
      return moment().local().isSameOrAfter(startDate);
    }
    return moment().local().isSameOrAfter(startDate) && moment().local().isSameOrBefore(endDate);
  })
  .map(o => ({...o}));
  let bundleId = -1;
  eligibleSeasonalPromotions.forEach(promo => {
    let containedItems = promotionMap.filter(p => p.group_id_list.includes(promo.groupId));
    // add tests or bundles that applied for this promotion
    promo.appliedTests = new Set();
    promo.appliedBundles = new Set();
    containedItems.forEach(item => {
      (item.item_type === "packagePriceId" ? promo.appliedTests : promo.appliedBundles)
        .add(item.item_id);
    });
    // get promo's original item
    promo.originalPrice = getOriginalPrice(promo, discountPanelList, testList);
    promo.isSelect = false;
    promo.category = "seasonalPromo";
    promo.price = promo.finalAmount;
    promo.bundleId = bundleId;
    promo.testIdsInPromo = getTestIdsInPromo(promo, discountPanelList);
    if (promo.quantity) {
      promo.isOpenXChooseYDialog = false;
    }
    bundleId--;
  });
  return eligibleSeasonalPromotions;
}

export function getOriginalPrice(promo, discountPanelList, testList) {
  let originalPrice = 0;
  promo.appliedBundles.forEach(bundleId => {
    let discountPanel = discountPanelList.find(panel => panel.bundleId === bundleId);
    if (discountPanel && discountPanel.originalPrice) {
      originalPrice += discountPanel.originalPrice;
    }
  });
  promo.appliedTests.forEach(testId => {
    let test = testList.find(t => t.id === testId);
    if (test && test.price) {
      originalPrice += test.price;
    }
  });
  return originalPrice;
}

// get tests included in the given promo
export function getTestIdsInPromo(promo, discountPanelList) {
  // get all tests in promo's applied bundles
  let testsInBundle = [];
  promo.appliedBundles.forEach(bundleId => {
    let bundle = discountPanelList.find(b => b.bundleId === bundleId);
    if (bundle) {
      let { testList, packageList } = bundle.bundleContent;
      testsInBundle = testList.map(t => t.testId)
        .concat(packageList.map(p => p.packageId));
    }
  });
  // get all tests that belong to current promo, remove duplicates
  return new Set([...promo.appliedTests, ...testsInBundle]);
}